import FJTextToSpeechItem from '../view/FJTextToSpeechItem.jsx';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import FJActionTextToSpeech from '../../../../redux/action/FJActionTextToSpeech.js';
import FJTTSPlayStore from '../../../../store/FJTTSPlayStore.js';
import FJConstant from '../../../../constants/FJConstant.js';
import FJEvent from '../../../../store/FJEvent.js';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant.js';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import FJUtil from '../../../../util/FJUtil.js';
import FJTextToSpeechUtil from '../../../../util/FJTextToSpeechUtil.js';

const FJTextToSpeechItemContainer = props => {
    useLocalStore();
    const dispatch = useDispatch();
    const { index, info, isLast, onDrag, dragId, isDragging, style } = props;
    const speechSelectId = useSelector(state => state.textToSpeech.speechSelectId);
    const currentSpeechList = useSelector(state => state.textToSpeech.currentSpeechList);
    const canDelete = currentSpeechList.length > 1;
    const creditNumber = useSelector(state => state.common.creditNumber);
    const _addSpeechParagraph = index => {
        FJTTSPlayStore.setPlayType(null);
        FJEvent.dispatch(FJ_EVENT_TYPE.STOP_CURRENT_SPEECH);
        dispatch(FJActionTextToSpeech.addSpeechParagraphAction(index));
        _resetBottomTime();
    };

    const _onTextChange = (id, value) => {
        dispatch(FJActionTextToSpeech.onTextChangeAction(id, value));
        _resetBottomTime();
    };

    const _onSelect = () => {
        if (info?.id !== speechSelectId) {
            FJEvent.dispatch(FJ_EVENT_TYPE.STOP_CURRENT_SPEECH);
            FJTTSPlayStore.setPlayType(null);
            _resetBottomTime();
        }
        dispatch(FJActionTextToSpeech.setSliceSpeechSelectIdAction(info?.id));
        dispatch(FJActionTextToSpeech.updateVoiceInfoAction());
    };

    const _onDelete = e => {
        e.stopPropagation();
        dispatch(FJActionTextToSpeech.deleteSpeechByIdAction(info?.id));
    };

    const _onGenerate = () => {
        FJUtil.eaLog('single_speech_play', {
            character: info.text.length,
            voice_name: info?.generationType !== FJConstant.CLONE_BY_SELF ? info.voiceInfo.name : 'clone',
            credits: FJTextToSpeechUtil.getUsedCreditByTextLength(info.text.trim().length),
        });

        dispatch(FJActionTextToSpeech.generateSpeechByIdAction(info?.id));
    };

    const _updateBottomCurrentTime = duration => {
        dispatch(FJActionTextToSpeech.updateBottomCurrentTimeAction(duration));
    };

    const _onEnded = () => {
        if (FJTTSPlayStore.getPlayType() === FJConstant.GLOBAL_PLAY) {
            // 选中下个
            const curIndex = currentSpeechList.findIndex(item => item.id === speechSelectId);
            if (currentSpeechList[curIndex + 1]) {
                dispatch(FJActionTextToSpeech.setSliceSpeechSelectIdAction(currentSpeechList[curIndex + 1].id));
                dispatch(FJActionTextToSpeech.updateVoiceInfoAction());
                FJTTSPlayStore.globalPlay(currentSpeechList[curIndex + 1].id);
            }
        }
        _resetBottomTime(0);
    };

    const _updateBottomTotalTime = duration => {
        dispatch(FJActionTextToSpeech.updateBottomTotalTimeAction(duration));
    };

    const _resetBottomTime = () => {
        dispatch(FJActionTextToSpeech.updateBottomTotalTimeAction(0));
        dispatch(FJActionTextToSpeech.updateBottomCurrentTimeAction(0));
    };
    const _updateBottomSpeechId = id => {
        dispatch(FJActionTextToSpeech.setSliceCurrentBottomSpeechIdAction(id));
    };

    const _updateIsPlay = bool => {
        if (bool) {
            _updateBottomTotalTime(info?.audioDuration);
            _updateBottomSpeechId(info?.id);
        }
        dispatch(FJActionTextToSpeech.setSliceIsPlayingInBottomAction(bool));
    };

    const _onDownload = url => {
        FJUtil.eaLog('speech_download_click', { position: 'single_section' });
        dispatch(FJActionTextToSpeech.multiDownloadAction([url]));
    };

    const _openLibrary = () => {
        if (info?.status === FJConstant.GENERATING) {
            return;
        }
        dispatch(FJActionTextToSpeech.openLibraryModalAction());
    };

    const hasGenerating = useMemo(() => {
        return currentSpeechList.find(item => item.status === FJConstant.GENERATING);
    }, [currentSpeechList]);

    return (
        <FJTextToSpeechItem
            index={index}
            isLast={isLast}
            onDrag={onDrag}
            dragId={dragId}
            isDragging={isDragging}
            style={style}
            addSpeechParagraph={_addSpeechParagraph}
            isSelected={speechSelectId === info?.id}
            info={info}
            onTextChange={_onTextChange}
            onSelect={_onSelect}
            onDelete={_onDelete}
            canDelete={canDelete}
            onGenerate={_onGenerate}
            updateBottomCurrentTime={_updateBottomCurrentTime}
            updateBottomTotalTime={_updateBottomTotalTime}
            updateIsPlay={_updateIsPlay}
            updateBottomSpeechId={_updateBottomSpeechId}
            onDownload={_onDownload}
            speechSelectId={speechSelectId}
            creditNumber={creditNumber}
            onEnded={_onEnded}
            openLibrary={_openLibrary}
            hasGenerating={hasGenerating}
        />
    );
};

FJTextToSpeechItemContainer.propTypes = {
    index: PropTypes.number,
    info: PropTypes.object,
    isLast: PropTypes.bool,
    onDrag: PropTypes.func,
    dragId: PropTypes.number,
    isDragging: PropTypes.bool,
    style: PropTypes.object,
};

export default FJTextToSpeechItemContainer;
